<template>
    <div>
      <b-row>
        <b-col>
          <b-form-radio-group
            v-if="visibleTemporaryDecision"
            class="pull-right"
            v-model="decision_type"
            :options="decision_options"

            id="radios-decision-type"
            name="radios-decision-type"
          ></b-form-radio-group>
        </b-col>

      </b-row>
      <b-form @submit.prevent="save">
        <b-row class="mt-4">
          <b-col class="mb-3" md="6" lg="4">
            <b-form-group :label="`${$t('PROTOCOL_NUMBER')} *`" label-size="sm">
              <b-form-input
                type="text"
                v-model.trim="request_protocol_number"
                name="protocol_number">
              </b-form-input>
              <validation-description :show="$v.request_protocol_number.$dirty && $v.request_protocol_number.$invalid">
                {{$t('FIELD_MANDATORY')}}
              </validation-description>
            </b-form-group>
          </b-col>
          <b-col class="mb-3" md="6" lg="4">
            <b-form-group :label="`${$t('DATE_OF_APPLICATION')} *`" label-size="sm">
              <date-picker :placeholder="$t('SELECT_DATE')" :value="date_receipt_request" @change="updateApplicationDate"></date-picker>
              <validation-description :show="$v.date_receipt_request.$dirty && $v.date_receipt_request.$invalid || (!this.initialData && date_receipt_request !== null && recognition_date !== null && date_receipt_request >= recognition_date)">
                <template v-if="showErrorDateReceipt">
                  {{$t('DATE_MUST_BE_LESS')}}
                </template>
                <template v-else>
                  {{$t('FIELD_MANDATORY')}}
                </template>
              </validation-description>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="hr-origin">
      <b-row class="mt-4">
        <b-col class="mb-3" lg="3" md="12">
          <b-form-group :label="`${$t('RECOGNITION_DATE')} *`" label-size="sm">
            <date-picker :placeholder="$t('SELECT_DATE')" :value="recognition_date" @change="updateRecognitionDate"></date-picker>
            <validation-description :show="$v.recognition_date.$dirty && $v.recognition_date.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" lg="3" md="12">
          <b-form-group :label="`${$t('DECISION_PROTOCOL_NUMBER')} *`" label-size="sm">
            <b-form-input
              type="text"
              v-model.trim="decision_protocol_number"
              name="decision_protocol_number">
            </b-form-input>
            <validation-description :show="$v.decision_protocol_number.$dirty && $v.decision_protocol_number.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" lg="3" md="12">
          <b-form-group :label="`${$t('COMPETENT_RECOGNITION_AUTHORITY')} *`"  label-size="sm">
            <b-select :options="options_decision_recognition"
                      type="select"
                      v-model="decision_recognition">
            </b-select>
            <validation-description :show="$v.decision_recognition.$dirty && $v.decision_recognition.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" lg="3" md="12" v-if="decision_recognition === 1">
          <b-form-group :label="`${$t('RECOGNIZED_AS')} *`"  label-size="sm">
            <b-select :options="options_recognized"
                      type="select"
                      v-model="recognized">
            </b-select>
            <validation-description :show="$v.recognized.$dirty && $v.recognized.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>

        <b-col class="mb-3" lg="3" md="12" v-if="decision_recognition === 0">
          <b-form-group :label="`${$t('NON_RECOGNITION_REASON')} * `"  label-size="sm">
            <b-select :options="options_non_recognition_reason"
                      type="select"
                      v-model="non_recognition_reason">
            </b-select>
            <validation-description :show="$v.non_recognition_reason.$dirty && $v.non_recognition_reason.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col v-if="visibleTemporaryDecision && Number(decision_type) === 2" class="mb-3" lg="2" md="3">
          <b-form-group :label="$t('EXPIRY_DATE')"  label-size="sm">
            <date-picker :value="expiry_date" @change="updateExpiryDate"></date-picker>

          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" lg="12">
          <b-form-group :label="`${$t('DESCRIPTION_DECISION')} *`" label-size="sm">
            <quill-editor
               class="editor"
               v-model="description_decision"
               :options="editorOptions"
            />
            <div class="content ql-editor"></div>
            <validation-description :show="$v.description_decision.$dirty && $v.description_decision.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col md="6" lg="6">
          <submit-button :disabled="applicant.status && applicant.status.id !== STATUS_IN_PROCESS || disabled" :loading="loading" :c_permission="C_RECOGNITION_SAVE_BUTTON"></submit-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import SubmitButton from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {getRecognition,createRecognition,updateRecognition} from '@/services/recognition/index'
  import {getUser} from "@/services/user";
  import i18n from '@/locale/index'
  import moment from 'moment'
  import {C_RECOGNITION_SAVE_BUTTON} from '@/shared/component_permission'
  import {ECONOMY_BIH, STATUS_COMPLETE, STATUS_IN_PROCESS, USER_DATA} from '@/shared/constants';
  import { quillEditor } from 'vue-quill-editor'

  export default {
    name: "RecognitionDecisionForm",
    data() {
      return {
        STATUS_IN_PROCESS,
        loading:false,
        mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
        C_RECOGNITION_SAVE_BUTTON,
        STATUS_COMPLETE,
        disabled: false,
        options_decision_recognition:[
          {value:null ,text:'-'},
          {value:1, text: i18n.t("RECOGNIZED")},
          {value:0,text: i18n.t("NOT_RECOGNIZED")}
        ],
        options_recognized:[
          {value: null, text: '-'},
          {value: 1, text: i18n.t('SHORT_CYCLE')},
          {value: 2, text: i18n.t('FIRST_CYCLE')},
          {value: 3, text: i18n.t('SECOND_CYCLE')},
          {value: 4, text: i18n.t('THIRD_CYCLE')},
          {value: 5, text: i18n.t('PREGRADUATE')},
          {value: 6, text: i18n.t('GRADUATE')},
          {value: 7, text: i18n.t('POSTGRADUATE')},
          {value: 8, text: i18n.t('OTHER')},
        ],
        options_non_recognition_reason: [
          {value:null, text:'-'},
          {value:1, text: i18n.t('INSTITUTION_NOT_RECOGNIZED')},
          {value:2, text: i18n.t('STUDY_PROGRAM_NOT_RECOGNIZED_ACCREDITED_COUNTRY_OF_ORIGIN')},
          {value:4, text: i18n.t('LEVEL_OF_QUALIFICATION_NOT_SAME_COMPARED')},
          {value:5, text: i18n.t('LACK_ECTS_LEARNING_OUTCOMES_WORKLOAD')},
          {value:6, text: i18n.t('OTHER_REASON')},
        ],
        editorOptions: {
          placeholder: ""
        },
        id:null,
        decision_protocol_number: null,
        description_decision: null,
        recognition_date:null,
        decision_recognition:null,
        recognized:null,
        non_recognition_reason: null,
        decision_type:1,
        expiry_date:null,
        request_protocol_number: null,
        date_receipt_request: null,
        decision_options:[
          {text: this.$t('PERMANENT'), value: 1},
          {text: this.$t('TEMPORARY'), value: 2},

        ],
        insert_user:{
          first_name:null,
          last_name:null
        },
        update_user:{
          first_name:null,
          last_name:null
        },
        created_at:null,
        updated_at:null,
        initialData: true,
        }
    },
    mixins: [getErrorMessage],
    components: {
      SubmitButton,
      DatePicker,
      ValidationDescription,
      quillEditor
    },
    validations() {
      return this.decision_recognition === 1 ? {
        decision_protocol_number: {required},
        recognition_date:{required},
        decision_recognition:{required},
        description_decision:{required},
        request_protocol_number: {required},
        date_receipt_request: {required},
        recognized: {required}
        } : {
        decision_protocol_number: {required},
        recognition_date:{required},
        decision_recognition:{required},
        description_decision:{required},
        request_protocol_number: {required},
        date_receipt_request: {required},
        non_recognition_reason: {required}
      }

    },
    computed: {
      showErrorDateReceipt() {
        if(this.date_receipt_request && this.recognition_date) {
          return this.date_receipt_request >= this.recognition_date;
        }
          return false;
      },
      user(){
        return JSON.parse(localStorage.getItem(USER_DATA))
      },
      visibleTemporaryDecision(){
        return Number(this.user.economy.id) === ECONOMY_BIH
      },
      language(){
        return localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
      },
      institution(){
        return this.$store.getters['institution/getInstitution']
      },
      applicant() {
        return this.$store.getters['applicant/getApplicant']
      },

    },
    methods: {
      updateApplicationDate(value) {
        this.initialData = false;
        this.date_receipt_request = value
      },
      updateRecognitionDate(value) {
        this.recognition_date = value
      },
      updateExpiryDate(value) {
        this.expiry_date = value
      },
      formatDate(value){
          if(value){
            const momentDate = new moment(value)
            return momentDate.format('DD.MM.YYYY HH:mm')
          } else {
              return null
          }
      },
      save() {
        this.initialData = false;
        let object = {
          recognition_date: this.recognition_date,
          description_decision: this.description_decision,
          decision_protocol_number: this.decision_protocol_number,
          decision_recognition: this.decision_recognition,
          recognized: this.recognized,
          non_recognition_reason: this.non_recognition_reason,
          decision_type: this.decision_type,
          expiry_date: this.expiry_date,
          request_protocol_number: this.request_protocol_number,
          date_receipt_request: this.date_receipt_request,
          tab:4
        }
        this.$v.$touch()
        if (this.$v.$invalid || this.showErrorDateReceipt) {
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 6000
          })
          return
        }
        if (this.id) {
          this.update(object)
        }
      },
      update(object) {
        this.loading = true
        updateRecognition(this.applicant.id,this.id, object)
          .then(response => {
            this.setData(response)
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
              'message': null,
              'type': 'error',
              'timeout': 2000
            })
          }).finally(()=>{
            this.loading = false
        })
      },
      fetchRecognition(applicantId){
        getRecognition(applicantId).then(response => {
             if(response.data.id === null) {
                 this.disabled = true
             }else{
                 this.disabled = false
             }
             this.setData(response)

        }, error => {
        })
      },
      setData(response){
        this.id = response.data.id
        this.recognition_date = response.data.recognition_date
        this.description_decision = response.data.description_decision
        this.decision_protocol_number = response.data.decision_protocol_number
        this.decision_recognition = Number(response.data.decision_recognition)
        this.recognized = response.data.recognized
        this.non_recognition_reason = response.data.non_recognition_reason
        this.expiry_date = response.data.expiry_date,
        this.created_at = response.data.created_at,
        this.updated_at = response.data.updated_at,
        this.insert_user = response.data.insert_user,
        this.update_user = response.data.update_user
        this.decision_type = response.data.decision_type
        this.date_receipt_request = response.data.date_receipt_request
        this.request_protocol_number = response.data.request_protocol_number
      },

      updateCountry(value) {
        this.country = value
      }
    },
    watch:{
      '$route.params.id':{
        handler(applicantId){
          this.fetchRecognition(applicantId)
        },
        immediate: true,
        deep:true
      },
      decision_type:{
        handler(value){

        }
      },
      decision_recognition: {
        handler(value) {
          if(value === 1) {
            this.non_recognition_reason = null;
          } else {
            this.recognized = null;
          }
        }
      }
    }
  }
</script>

<style scoped>
.quill-editor,
.content {
  background-color: white;
}

.editor {
  height: 250px;
}
</style>
